import React from 'react';

class TableHead extends React.PureComponent {
  static defaultProps = {
    border: false
  };

  render() {
    const { children, border, extraCls } = this.props;
    let cls = '';
    if (!border) {
      cls += ' no-border';
    }
    if (extraCls) {
      cls += ' ' + extraCls;
    }

    return <thead className={cls}>{children}</thead>;
  }
}

export default TableHead;
